import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { db } from '../../firebase';
import { collection, query, where, onSnapshot, getDocs, Timestamp, doc, getDoc } from 'firebase/firestore';

export default function Home({ darkMode, onOpenOrder, userId: propUserId, companyCode: propCompanyCode, unitCode: propUnitCode }) {
  const navigate = useNavigate();
  const location = useLocation();
  /*const companyCode = location?.state?.companyCode || 
                     (location?.search ? new URLSearchParams(location.search).get('code') : null) || 
                     localStorage.getItem('companyCode') || null;
  const userId = location?.state?.userId || localStorage.getItem('userId') || null;
  const unitCode = location?.state?.unitCode || 
                  (location?.search ? new URLSearchParams(location.search).get('unit') : null) || 
                  localStorage.getItem('unitCode') || null;*/
                   const companyCode =
                   propCompanyCode ||
  location?.state?.companyCode ||
  new URLSearchParams(location.search).get("code") ||
  sessionStorage.getItem("companyCode") ||
  localStorage.getItem("companyCode") ||
  null;

const userId =
propUserId ||   
  location?.state?.userId ||
  sessionStorage.getItem("userId") ||
  localStorage.getItem("userId") ||
  null;

const unitCode =
propUnitCode ||
  location?.state?.unitCode ||
  new URLSearchParams(location.search).get("unit") ||
  sessionStorage.getItem("unitCode") ||
  localStorage.getItem("unitCode") ||
  null;

  const [stats, setStats] = useState({
    deliveredOrders: 0,
    itemsToDeliver: 0,
    todaysCashReceived: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [assignedTableIds, setAssignedTableIds] = useState([]);

  const [serviceAreas, setServiceAreas] = useState([]);
const [selectedServiceArea, setSelectedServiceArea] = useState('');
const [defaultServiceArea, setDefaultServiceArea] = useState('');
const [assignedTables, setAssignedTables] = useState([]);
const [companyName, setCompanyName] = useState("N/A");
const [tableStatusMap, setTableStatusMap] = useState({});
const [billingPreference, setBillingPreference] = useState(null);
/*const fetchServerServiceArea = async () => {
  if (!companyCode || !userId) return;

  try {
    const q = query(
      collection(db, "users"),
      where("userId", "==", userId)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const data = snapshot.docs[0].data();

      if (data.serviceArea) {
        setSelectedServiceArea(data.serviceArea);
        console.log("Server serviceArea ID:", data.serviceArea);
      }
    }

  } catch (err) {
    console.error("Error fetching server service area:", err);
  }
};*/
const isManagerView = !!onOpenOrder;
const [displayName, setDisplayName] = useState("N/A");

useEffect(() => {
  const fetchUserName = async () => {
    if (!companyCode || !unitCode) return;

    try {
      let targetUserId;

      if (onOpenOrder) {
        //  Manager flow → get manager
        const managerQuery = query(
          collection(db, "users"),
          where("companyCode", "==", companyCode),
          where("unitCode", "==", unitCode),
          where("role", "==", "unit_manager")
        );

        const snap = await getDocs(managerQuery);

        if (!snap.empty) {
          targetUserId = snap.docs[0].data().userId;
        }
      } else {
        //  Server flow → use current user
        targetUserId = userId;
      }

      if (targetUserId) {
        const name = targetUserId.split("#")[1];
        setDisplayName(name);
      }

    } catch (err) {
      console.error("Error fetching user name:", err);
      setDisplayName("Unknown");
    }
  };

  fetchUserName();
}, [companyCode, unitCode, userId, onOpenOrder]);

const [unitName, setUnitName] = useState("N/A");

useEffect(() => {
  const fetchCompanyName = async () => {
    if (!companyCode) return;

    try {
      const companyDoc = await getDoc(doc(db, "companies", companyCode));

      if (companyDoc.exists()) {
        setCompanyName(companyDoc.data().name || "N/A");
      } else {
        console.warn("No company found for code:", companyCode);
      }
    } catch (error) {
      console.error("Error fetching company:", error);
    }
  };

  fetchCompanyName();
}, [companyCode]);

useEffect(() => {
  const fetchUnitName = async () => {
    if (!unitCode) return;

    try {
      const unitDoc = await getDoc(doc(db, "units", unitCode));
      if (unitDoc.exists()) {
        setUnitName(unitDoc.data().unitName || "N/A");
      } else {
        console.warn("No unit found for code:", unitCode);
      }
    } catch (error) {
      console.error("Error fetching unit:", error);
    }
  };

  fetchUnitName();
}, [unitCode]);

const fetchServerServiceArea = async () => {
  if (!companyCode || !userId) return;

  try {

    const sessionKey = `selectedServiceArea_${userId}_${unitCode}`;

    // Check session first
    const savedArea = sessionStorage.getItem(sessionKey);

    if (savedArea) {
      console.log("Using session service area:", savedArea);
      setSelectedServiceArea(savedArea);
      return;
    }

    // Fetch from Firestore
    const q = query(
      collection(db, "users"),
      where("userId", "==", userId)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const data = snapshot.docs[0].data();

      if (data.serviceArea) {
        console.log("Firestore serviceArea:", data.serviceArea);

        setSelectedServiceArea(data.serviceArea);

        // Store per-user session
        sessionStorage.setItem(sessionKey, data.serviceArea);
      }
    }

  } catch (err) {
    console.error("Error fetching server service area:", err);
  }
};
const fetchServiceAreas = async () => {
  if (!companyCode || !unitCode) return;

  try {
    const q = query(
      collection(db, "serviceAreas"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode)
    );

    const snapshot = await getDocs(q);

    const areas = snapshot.docs.map(doc => ({
      id: doc.data().id,
      serviceAreaName: doc.data().serviceAreaName
    }));

    console.log("Loaded service areas:", areas);
    console.log("Selected service area:", selectedServiceArea);

    setServiceAreas(areas);

  } catch (err) {
    console.error("Error fetching service areas:", err);
  }
};

const handleServiceAreaChange = (event) => {
  const newArea = event.target.value;

  setSelectedServiceArea(newArea);

  const sessionKey = `selectedServiceArea_${userId}_${unitCode}`;

  sessionStorage.setItem(sessionKey, newArea);

  console.log("Service area switched to:", newArea);
};

useEffect(() => {
  const fetchBillingPreference = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Billing Process")
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const prefValue = snapshot.docs[0].data().preferenceValue;

        console.log("Billing Preference:", prefValue);

        setBillingPreference(Number(prefValue));
      }
    } catch (err) {
      console.error("Error fetching billing preference:", err);
    }
  };

  fetchBillingPreference();
}, [companyCode, unitCode]);

  /*const fetchAssignedTables = async () => {
    if (!companyCode || !userId || !unitCode) {
      console.warn('ServerHome: Missing parameters for fetching assigned tables', { companyCode, userId, unitCode });
      return [];
    }

    const areaToUse = selectedServiceArea ;
    try {
      const tablesQuery = query(
        collection(db, 'tables'),
        where('companyCode', '==', companyCode),
        where('unitCode', '==', unitCode),
        where('assignedServer', '==', userId),
        where('serviceArea', '==', areaToUse)
      );
      const tablesSnapshot = await getDocs(tablesQuery);
      const tableIds = tablesSnapshot.docs.map(doc => doc.data().tableId);
      console.log('ServerHome: Fetched assigned tables:', { userId, unitCode, tableIds });
      return tableIds;
    } catch (error) {
      console.error('ServerHome: Error fetching assigned tables:', { userId, unitCode, error });
      setError(`Failed to fetch assigned tables: ${error.message}`);
      return [];
    }
  };*/
  /*const fetchAssignedTables = async () => {
  if (!companyCode || !userId || !unitCode) {
    console.warn('ServerHome: Missing parameters for fetching assigned tables', { companyCode, userId, unitCode });
    return [];
  }

  const areaToUse = selectedServiceArea;

  try {
    const tablesQuery = query(
      collection(db, 'tables'),
      where('companyCode', '==', companyCode),
      where('unitCode', '==', unitCode),
      //where('assignedServer', '==', userId),
      where('serviceArea', '==', areaToUse),
      where('tableStatus', 'in', ['Available','Occupied','Reserved'])
    );

    const tablesSnapshot = await getDocs(tablesQuery);

    const tables = tablesSnapshot.docs.map(doc => ({
      tableId: doc.data().tableId,
      tableName: doc.data().tableName || doc.data().tableId
    }));

    setAssignedTables(tables);

    const tableIds = tables.map(t => t.tableId);

    console.log('Assigned tables:', tables);

    return tableIds;

  } catch (error) {
    console.error('ServerHome: Error fetching assigned tables:', error);
    setError(`Failed to fetch assigned tables: ${error.message}`);
    return [];
  }
};*/
  

const fetchAssignedTables = async () => {
  if (!companyCode || !unitCode || !selectedServiceArea) {
    console.warn('ServerHome: Missing parameters for fetching assigned tables', { companyCode, selectedServiceArea, unitCode });
    return [];
  }

  try {
    const tablesQuery = query(
      collection(db, "tables"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode),
      where("serviceArea", "==", selectedServiceArea),
      where("tableStatus", "in", ["Available", "Occupied", "Reserved"])
    );

    const snapshot = await getDocs(tablesQuery);

    /*const tables = snapshot.docs.map(doc => ({
      tableId: doc.data().tableId,
      tableName: doc.data().tableName || doc.data().tableId
    }));*/
    let tables = snapshot.docs.map(doc => ({
  tableId: doc.data().tableId,
  tableName: doc.data().tableName || doc.data().tableId
}));

// Server should not see tables when billing preference is 0
if (!isManagerView && billingPreference === 0) {
  tables = [];
}

    setAssignedTables(tables);

    console.log("Tables by service area:", tables);

    return tables.map(t => t.tableId);

  } catch (error) {
    console.error("Error fetching tables:", error);
    setError(error.message);
    return [];
  }
};

  useEffect(() => {
   
    console.log('ServerHome: Initial state:', { companyCode, userId, unitCode, query: location?.search });
    if (!companyCode || !userId || !unitCode) {
      console.error('ServerHome: Missing required parameters', { companyCode, userId, unitCode });
      setError('Authentication or unit required. Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
      setIsLoading(false);
      return;
    }
fetchServerServiceArea();   // load saved service area
      
    fetchServiceAreas();

    let unsubscribe = () => {};
     let unsubscribeCart = () => {};
    const fetchStats = async () => {
      try {
        const tableIds = await fetchAssignedTables();
        setAssignedTableIds(tableIds);
        if (tableIds.length === 0) {
          console.warn('ServerHome: No tables assigned to server for unit:', { userId, unitCode });
          setStats({
            deliveredOrders: 0,
            itemsToDeliver: 0,
            todaysCashReceived: 0,
          });
          console.log('ServerHome: No assigned tables, stats set to zero');
          setIsLoading(false);
          return () => {};
        }

        console.log('ServerHome: Setting up snapshot listener for companyCode:', companyCode, 'unitCode:', unitCode);
        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);
        const todayEnd = new Date();
        todayEnd.setHours(23, 59, 59, 999);

        const ordersQuery = query(
          collection(db, 'orders'),
          where('companyCode', '==', companyCode),
          where('unitCode', '==', unitCode),
          where('tableId', 'in', tableIds.length > 0 ? tableIds : ['__dummy__']) // Prevent empty 'in' query
        );

        unsubscribe = onSnapshot(ordersQuery, (snapshot) => {
          try {

            const tableMap = {}; 

            const orders = snapshot.docs
              .filter(doc => {
                const createdAt = doc.data().createdAt;
                if (createdAt instanceof Timestamp) {
                  const date = createdAt.toDate();
                  return date >= todayStart && date <= todayEnd && tableIds.includes(doc.data().tableId);
                }
                return false;
              });

              //  LOOP FOR TABLE COLOR LOGIC
    /*orders.forEach(doc => {
      const data = doc.data();
      const tableId = data.tableId;

      const hasServedItems = (data.items || []).some(
        item => item.status === "Served"
      );
      const hasActiveItems = (data.items || []).some(item =>
    ["Confirmed", "Preparing", "Ready"].includes(item.status)
  );

      const isPaid = data.orderStatus === "Paid";
      const isOpen = data.orderStatus === "Open";
      const billingPref = data.billingPreference;

      // Served but NOT Paid
     /* if (hasServedItems && !isPaid && isManagerView) {
        tableMap[tableId] = "pendingPayment";
      }*/
      /*if (
    hasServedItems &&
    !isPaid &&
    (
      (billingPref === 0 && isManagerView) ||  // only manager
      (billingPref === 1 || billingPref === 2 || billingPref === 3) // both
    )
  ) {
    tableMap[tableId] = "pendingPayment";
  }

  else if (
    isOpen &&
    hasActiveItems &&
    [1, 2, 3].includes(billingPref)
  ) {
    tableMap[tableId] = "activeOrder";
  }
    });*/

   orders.forEach(doc => {
  const data = doc.data();
  const tableId = data.tableId;

  /*const items = data.items || [];
  if (!items.length) return;

  const billingPref = data.billingPreference;

  //  If billingPreference = 0 AND it's server → NO COLOR
  if (!isManagerView && billingPref === 0) {
    return; // skip assigning any color
  }

  //  Priority order
  const statusPriority = [
    "Served",
    "Ready",
    "Preparing",
    "Confirmed",
    "Ordered"
  ];

  let finalStatus = null;

  for (let status of statusPriority) {
    if (items.some(item => item.status === status)) {
      finalStatus = status;
      break;
    }
  }*/

  /*if (finalStatus) {
    tableMap[tableId] = finalStatus;
  }*/
 /*if (finalStatus) {
  tableMap[tableId] = {
    status: finalStatus,
    orderId: doc.id, // or data.orderId if you have custom field
    createdAt: data.createdAt?.toDate?.() || null
  };
}*/

//  REMOVE table color AFTER PAYMENT
if (data.orderStatus === "Paid") {
  return; 
}

const items = data.items || [];
console.log(
  "TABLE:",
  tableId,
  items.map(i => i.status)
);
if (!items.length) return;

const billingPref = data.billingPreference;

// Skip for server when billingPref = 0
if (!isManagerView && billingPref === 0) return;

// NEW PRIORITY (Ordered first)
let finalStatus = null;

if (items.some(item => item.status === "Ordered")) {
  finalStatus = "Ordered";
} else if (items.some(item => item.status === "Confirmed")) {
  finalStatus = "Confirmed";
} else if (items.some(item => item.status === "Preparing")) {
  finalStatus = "Preparing";
} else if (items.some(item => item.status === "Ready")) {
  finalStatus = "Ready";
} else if (items.some(item => item.status === "Served")) {
  finalStatus = "Served";
}

if (finalStatus) {
  tableMap[tableId] = {
    status: finalStatus,
    orderId: doc.id,
    createdAt: data.createdAt?.toDate?.() || null
  };
}
});

    setTableStatusMap(tableMap); 

            const deliveredOrders = orders.filter(doc => doc.data().status === 'Delivered').length;
            const itemsToDeliver = orders
              .filter(doc => doc.data().status === 'Ready')
              .reduce((total, doc) => total + (doc.data().items?.length || 0), 0);
            const todaysCashReceived = orders
              .filter(doc => doc.data().status === 'Delivered' && doc.data().paymentMethod === 'cash' && doc.data().paid)
              .reduce((total, doc) => total + (Number(doc.data().totalAmount) || 0), 0);

            setStats({
              deliveredOrders,
              itemsToDeliver,
              todaysCashReceived,
            });
            console.log('ServerHome: Fetched stats:', {
              deliveredOrders,
              itemsToDeliver,
              todaysCashReceived,
              assignedTableIds: tableIds,
              unitCode,
            });

            setIsLoading(false);
          } catch (err) {
            console.error('ServerHome: Error processing snapshot:', err);
            setError(`Failed to load statistics: ${err.message}`);
            setIsLoading(false);
          }
        }, (err) => {
          console.error('ServerHome: Error fetching stats:', err);
          setError(`Failed to load statistics: ${err.message}`);
          setIsLoading(false);
        });

       

const cartQuery = query(
  collection(db, "carts"),
  where("companyCode", "==", companyCode),
  where("unitCode", "==", unitCode),
  where("tableId", "in", tableIds.length > 0 ? tableIds : ["__dummy__"])
);

unsubscribeCart = onSnapshot(cartQuery, (snapshot) => {
  try {
    const cartMap = {};

    snapshot.docs.forEach(doc => {
      const data = doc.data();
      const tableId = data.tableId;

      const items = data.items || [];

      // billingPref restriction (same as orders)
      if (!isManagerView && data.billingPreference === 0) {
        return;
      }

      // Check Ordered from cart
      const hasOrdered =
        data.cartStatus === "Ordered" ||
        items.some(item => item.status === "Ordered");

      if (hasOrdered) {
        cartMap[tableId] = "Ordered";
      }
    });

    // Merge cart + orders
   setTableStatusMap(prev => {
  const merged = { ...prev };

  const priority = {
    Ordered: 5,
    Confirmed: 4,
    Preparing: 3,
    Ready: 2,
    Served: 1
  };

  Object.keys(cartMap).forEach(tableId => {
    const cartStatus = "Ordered";

    if (!merged[tableId]) {
      merged[tableId] = { status: cartStatus };
    } else {
      const currentStatus = merged[tableId].status;

      if (priority[cartStatus] > priority[currentStatus]) {
        merged[tableId] = {
          ...merged[tableId],   
          status: cartStatus
        };
      }
    }
  });

  return merged;
});
  } catch (err) {
    console.error("Cart snapshot error:", err);
  }
});

        return unsubscribe;
        return unsubscribeCart;
      } catch (err) {
        console.error('ServerHome: Error setting up stats listener:', err);
        setError(`Failed to load statistics: ${err.message}`);
        setIsLoading(false);
        return () => {};
      }
    };

    fetchStats().then(unsub => {
      unsubscribe = unsub;
    });

    //return () => unsubscribe();
    return () => {
  unsubscribe();
  unsubscribeCart();
};

    
  }, [companyCode, userId, unitCode, selectedServiceArea, billingPreference, navigate]);

 

  const handleViewOrders = () => {
    console.log('ServerHome: Navigating to /servers/orders', { companyCode, unitCode, userId });
    navigate(`/servers/orders?code=${companyCode}&unit=${unitCode}`, {
      state: { companyCode, unitCode, userId },
    });
  };

  const handleViewPayments = () => {
    console.log('ServerHome: Navigating to /servers/payment', { companyCode, unitCode, userId });
    navigate(`/servers/payment?code=${companyCode}&unit=${unitCode}`, {
      state: { companyCode, unitCode, userId },
    });
  };

  const [now, setNow] = useState(Date.now());

useEffect(() => {
  const interval = setInterval(() => {
    setNow(Date.now());
  }, 60000); // update every 1 minute

  return () => clearInterval(interval);
}, []);


  const getTimeDiff = (createdAt) => {
  if (!createdAt) return "";

  const diffMs = now - createdAt.getTime();
  const diffMin = Math.floor(diffMs / 60000);

  if (diffMin < 1) return "Just now";
  if (diffMin < 60) return `${diffMin} min ago`;

  const diffHr = Math.floor(diffMin / 60);
  return `${diffHr} hr ago`;
};


  const selectedAreaName =
  serviceAreas.find(a => a.id === selectedServiceArea)?.serviceAreaName || "N/A";

  const serverName = userId?.split("#")[1] || 'Unknown Server';
  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center', bgcolor: darkMode ? '#1e1e2f' : '#f9fafb' }}>
        <CircularProgress sx={{ color: darkMode ? '#93c5fd' : '#735DA5' }} />
        <Typography variant="h6" sx={{ mt: 2, color: darkMode ? '#d1d5db' : '#1f2937' }}>
          Loading server dashboard...
        </Typography>
      </Container>
    );
  }

  const STATUS_COLORS = {
  Ordered: "#d3d3d3",
  Confirmed: "#2196f3",
  Preparing: "#ff9800",
  Ready: "#90ee90",
  Served: "#006400",
};

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: darkMode ? '#1e1e2f' : '#f9fafb', overflowX: "hidden"}}>
      <Box sx={{
    mb: 3,
    display: "flex",
    gap: 2,
    alignItems: { xs: "flex-start", md: "center" },
    flexDirection: { xs: "column", md: "row" },
  }}>
  
  <FormControl sx={{ minWidth: { xs: "100%", md: 200 } }}>
    <InputLabel>Service Area</InputLabel>
    {/*<Select
      value={selectedServiceArea}
      label="Service Area"
      onChange={(e) => setSelectedServiceArea(e.target.value)}
    >*/}
   <Select
  value={selectedServiceArea}
  label="Service Area"
  onChange={handleServiceAreaChange}
>
      {serviceAreas.map(area => (
        <MenuItem key={area.id} value={area.id}>
          {area.serviceAreaName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

 <Typography
  /*variant="h4"
  sx={{
    color: darkMode ? '#d1d5db' : '#1f2937',
    textAlign: "left", // align text left within the space
    flexGrow: 1,
    ml: 4, // small left margin
  }}*/
 variant="h5"
  sx={{
    color: darkMode ? "#d1d5db" : "#1f2937",
    flexGrow: 1,
    wordBreak: "break-word",
    fontSize: { xs: "18px", md: "28px" }
  }}
>
  {displayName} | {unitName} | {companyName}
</Typography>


      <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 0.5,
      alignItems: "flex-start",
      minWidth: "150px"
    }}
  >
    {Object.entries(STATUS_COLORS).map(([status, color]) => (
      <Box key={status} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 14,
            height: 14,
            bgcolor: color,
            borderRadius: "3px",
            border: "1px solid #ccc"
          }}
        />
        <Typography
          variant="caption"
          sx={{ color: darkMode ? "#d1d5db" : "#374151" }}
        >
          {status}
        </Typography>
      </Box>
    ))}
  </Box>
</Box>
      {/*<Typography variant="h4" gutterBottom sx={{ color: darkMode ? '#d1d5db' : '#1f2937' }}>
        Server Dashboard - {unitName}| Area: {selectedAreaName}
      </Typography>*/}
      {error && (
        <Typography variant="h6" color="error" sx={{ mb: 2, textAlign: 'center' }}>
          {error}
        </Typography>
      )}

{!isManagerView && billingPreference === 0 && (
  <Box
    sx={{
      width: "100%",
      textAlign: "center",
      py: 6
    }}
  >
    <Typography
      variant="h6"
      sx={{
        color: darkMode ? "#f3f4f6" : "#374151",
        fontWeight: 600
      }}
    >
      Ordering is not available for waiters because Billing Preference is set to direct billing.
    </Typography>
  </Box>
)}
      <Grid container spacing={4} sx={{ mb: 4 }}>
<Grid container spacing={3} sx={{ mb: 4, mt:3}}>
  {assignedTables.map((table) => (
  <Grid item xs={12} sm={6} md={4} key={table.tableId} lg={3}>
    <Card
      elevation={3}
      onClick={() => {
  if (onOpenOrder) {
    // Manager flow
    onOpenOrder({
      tableId: table.tableId,
      serviceArea: selectedServiceArea,
      companyCode,
      unitCode,
      userId
    });
  } else {
    //  Normal server login flow
    navigate(
      `/servers/orders?code=${companyCode}&unit=${unitCode}&table=${table.tableId}`,
      {
        state: {
          companyCode,
          unitCode,
          userId,
          tableId: table.tableId,
          serviceArea: selectedServiceArea
        }
      }
    );
  }
}}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        p: 2,
        cursor: "pointer",
        height: "100%",
        //bgcolor: darkMode ? "#3a3a5c" : "#ffffff",
         /*bgcolor:
      tableStatusMap[table.tableId] === "pendingPayment"
        ? "#f02828"   // 🔴 RED
        : (darkMode ? "#3a3a5c" : "#ffffff"),*/
/*bgcolor:
  tableStatusMap[table.tableId] === "pendingPayment"
    ? "#f02828"   // 🔴 RED
    : tableStatusMap[table.tableId] === "activeOrder"
    ? "#facc15"   // 🟡 YELLOW
    : (darkMode ? "#3a3a5c" : "#ffffff"),*/
    bgcolor: (() => {
  const status = tableStatusMap[table.tableId]?.status;

  switch (status) {
    case "Ordered":
      return "#d3d3d3"; // light grey
    case "Confirmed":
      return "#2196f3"; // blue
    case "Preparing":
      return "#ff9800"; // orange
    case "Ready":
      return "#90ee90"; // light green
    case "Served":
      return "#006400"; // dark green
    default:
      return darkMode ? "#3a3a5c" : "#ffffff";
  }
})(),
    color:
      tableStatusMap[table.tableId]?.status === "pendingPayment"
        ? "#fff"
        : "inherit",
        transition: "transform 0.2s",
        "&:hover": { transform: "scale(1.03)" },
      }}
    >
      <Typography
        variant="h6"
        sx={{ color: darkMode ? "#d1d5db" : "#1f2937", mb: 1 }}
      >
        Table: {table.tableName}
      </Typography>

      {tableStatusMap[table.tableId]?.orderId && (
  <Typography
    variant="body2"
    sx={{
      color: darkMode ? "#f8f8f8" : "#f8f8f8",
      fontSize: "13px"
    }}
  >
    Order ID: {tableStatusMap[table.tableId].orderId}
  </Typography>
)}
{tableStatusMap[table.tableId]?.createdAt && (
      <Typography
        variant="body2"
        sx={{
          color: darkMode ? "#f8f8f8" : "#f8f8f8",
          fontSize: "12px"
        }}
      >
        Occupied For:{getTimeDiff(tableStatusMap[table.tableId].createdAt)}
      </Typography>
    )}

      {/*<Button
        variant="contained"
        size="small"
        /*onClick={() =>
          navigate(
            `/servers/orders?code=${companyCode}&unit=${unitCode}&table=${table.tableId}`,
            { state: { companyCode, unitCode, userId, tableId: table.tableId, serviceArea: selectedServiceArea } }
          )
        }*/
      /*onClick={() => {
  if (onOpenOrder) {
    // Manager flow
    onOpenOrder({
      tableId: table.tableId,
      serviceArea: selectedServiceArea,
      companyCode,
      unitCode,
      userId
    });
  } else {
    // Normal server login flow
    navigate(
      `/servers/orders?code=${companyCode}&unit=${unitCode}&table=${table.tableId}`,
      {
        state: {
          companyCode,
          unitCode,
          userId,
          tableId: table.tableId,
          serviceArea: selectedServiceArea
        }
      }
    );
  }
}}
        sx={{
          alignSelf: "center",
          bgcolor: darkMode ? "#4b5563" : "#735DA5",
          "&:hover": {
            bgcolor: darkMode ? "#6b7280" : "#a583f2",
          },
        }}
      >
       Orders
      </Button>*/}

    </Card>
  </Grid>
))
  }
</Grid>
        {/*<Grid item xs={12} sm={4}>
          <Card
            elevation={3}
            sx={{
              textAlign: 'center',
              transition: 'transform 0.2s',
              '&:hover': { transform: 'scale(1.05)' },
              bgcolor: darkMode ? '#3a3a5c' : '#ffffff',
            }}
          >
            <CardContent>
              <Typography variant="h6" color={darkMode ? '#9ca3af' : 'text.secondary'}>
                Orders Delivered
              </Typography>
              <Typography variant="h4" sx={{ mt: 1, color: darkMode ? '#a583f2' : '#735DA5' }}>
                {stats.deliveredOrders}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card
            elevation={3}
            sx={{
              textAlign: 'center',
              transition: 'transform 0.2s',
              '&:hover': { transform: 'scale(1.05)' },
              bgcolor: darkMode ? '#3a3a5c' : '#ffffff',
            }}
          >
            <CardContent>
              <Typography variant="h6" color={darkMode ? '#9ca3af' : 'text.secondary'}>
                Items to Deliver
              </Typography>
              <Typography variant="h4" sx={{ mt: 1, color: darkMode ? '#facc15' : '#f59e0b' }}>
                {stats.itemsToDeliver}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card
            elevation={3}
            sx={{
              textAlign: 'center',
              transition: 'transform 0.2s',
              '&:hover': { transform: 'scale(1.05)' },
              bgcolor: darkMode ? '#3a3a5c' : '#ffffff',
            }}
          >
            <CardContent>
              <Typography variant="h6" color={darkMode ? '#9ca3af' : 'text.secondary'}>
                Today's Cash Received
              </Typography>
              <Typography variant="h4" sx={{ mt: 1, color: darkMode ? '#a3e4d7' : '#2e7d32' }}>
                ₹{stats.todaysCashReceived.toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>*/}
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        {/*<Button
          variant="contained"
          color="primary"
          onClick={handleViewOrders}
          sx={{ 
            minWidth: 150, 
            bgcolor: darkMode ? '#4b5563' : '#735DA5', 
            '&:hover': { bgcolor: darkMode ? '#6b7280' : '#a583f2' } 
          }}
        >
          View Orders
        </Button>*/}
        {(isManagerView || billingPreference !== 0) && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleViewPayments}
          sx={{ 
            minWidth: 150, 
            bgcolor: darkMode ? '#4b5563' : '#735DA5', 
            '&:hover': { bgcolor: darkMode ? '#6b7280' : '#a583f2' } 
          }}
        >
          View Payments
        </Button>
        )}
      </Box>
    </Container>
  );
}